import { c as _c } from "react/compiler-runtime";
import { BI_CATEGORY_BEHAVIOR_IN_ROOM, BI_EVENT_DEVICE_INCOMPATIBLE } from '@/constants/bi-sdk';
import { useBISdkContext } from '@/context/BISdkContext';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import { useConfigsContext } from '@/context/ConfigsContext';
import useInitialTrailerViewMedia from '@/hooks/useInitialTrailerViewMedia';
import usePollTrailerViewBlendVisionVodStatus from '@/hooks/usePollTrailerViewBlendVisionVodStatus';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useInterval } from 'usehooks-ts';
export const MEDIA_TYPE = {
  VIDEO: 'video',
  IMAGE: 'image'
} as const;
export const CAROUSEL_DURATION_MS = 2500;
export const VOD_STATUS_FAILED_LIST = [
// the status of vod reference: https://developers.blendvision.com/zh/docs/api/bv-one/public-cms-service-list-vo-ds#responses
'VOD_STATUS_FAILED', 'VOD_STATUS_CANCELLED', 'VOD_STATUS_DELETED'];
export const isVODStatusFailed = (status: string) => VOD_STATUS_FAILED_LIST.includes(status);
const isPlayableVideo = (video: {
  isPlaceholder?: boolean;
  url?: string;
  playbackToken?: string;
  dashUri?: string;
  hlsUri?: string;
}) => !video.isPlaceholder && (Boolean(video.url) || Boolean(video.playbackToken && video.dashUri && video.hlsUri));
const isDisplayableImage = (image: {
  isPlaceholder?: boolean;
  url?: string;
}) => !image.isPlaceholder && Boolean(image.url);
export const useTrailerViewMedia = t0 => {
  const $ = _c(40);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    sendBI: t2,
    video
  } = t1;
  const sendBI = t2 === undefined ? true : t2;
  let t3;
  if ($[2] !== video) {
    t3 = video ?? {};
    $[2] = video;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const {
    backgroundPlay: t4,
    containerClassName
  } = t3;
  const backgroundPlay = t4 === undefined ? false : t4;
  const [currentIndex, setCurrentIndex] = useState(0);
  const {
    roomData
  } = useCheckEnterRoomContext();
  const [playKey, setPlayKey] = useState(0);
  const {
    sendBIReport
  } = useBISdkContext();
  const {
    accountType
  } = useConfigsContext();
  const {
    videos: originVideos,
    images,
    isMediaLoading,
    isVideoLoading
  } = useInitialTrailerViewMedia(roomData.id);
  let t5;
  let t6;
  if ($[4] !== accountType || $[5] !== roomData.id || $[6] !== roomData.title || $[7] !== sendBI || $[8] !== sendBIReport) {
    t5 = () => {
      if (!sendBI) {
        return;
      }
      sendBIReport({
        ev: BI_EVENT_DEVICE_INCOMPATIBLE,
        category: BI_CATEGORY_BEHAVIOR_IN_ROOM,
        a1: accountType,
        a2: window.location.href,
        a3: roomData.title,
        a4: roomData.id
      });
    };
    t6 = [accountType, roomData.id, roomData.title, sendBIReport, sendBI];
    $[4] = accountType;
    $[5] = roomData.id;
    $[6] = roomData.title;
    $[7] = sendBI;
    $[8] = sendBIReport;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  useEffect(t5, t6);
  const polledVideos = usePollTrailerViewBlendVisionVodStatus(originVideos);
  const videos = polledVideos ?? originVideos;
  let t7;
  if ($[11] !== images || $[12] !== isVideoLoading || $[13] !== videos) {
    let t8;
    if ($[15] !== isVideoLoading) {
      t8 = video_0 => isVideoLoading || isPlayableVideo(video_0);
      $[15] = isVideoLoading;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    const typedVideos = videos.filter(t8).map(_temp);
    const typedImages = images.filter(isDisplayableImage).map(_temp2);
    t7 = [...typedVideos, ...typedImages];
    $[11] = images;
    $[12] = isVideoLoading;
    $[13] = videos;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let list = t7;
  if (!isMediaLoading && list.length === 0 && roomData.image) {
    let t8;
    if ($[17] !== roomData.image) {
      t8 = [{
        duration: CAROUSEL_DURATION_MS,
        type: MEDIA_TYPE.IMAGE,
        url: roomData.image,
        isPlaceholder: false,
        key: roomData.image
      }];
      $[17] = roomData.image;
      $[18] = t8;
    } else {
      t8 = $[18];
    }
    list = t8;
  }
  const mediaList = list;
  const currentMedia = mediaList[currentIndex] || null;
  const isLoading = isMediaLoading;
  const isEmpty = !isLoading && !(mediaList.length > 0 && currentMedia !== null);
  let t8;
  if ($[19] !== currentIndex || $[20] !== mediaList) {
    t8 = () => {
      const total = mediaList.length;
      const currentMedia_0 = mediaList[currentIndex] || null;
      setCurrentIndex(prev => {
        const nextIndex = (prev + 1) % total;
        if (nextIndex === prev && currentMedia_0?.type === MEDIA_TYPE.VIDEO) {
          setPlayKey(_temp3);
        }
        return (prev + 1) % total;
      });
    };
    $[19] = currentIndex;
    $[20] = mediaList;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  const goNext = t8;
  let t9;
  if ($[22] !== goNext) {
    t9 = () => {
      goNext();
    };
    $[22] = goNext;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const handleVideoEnded = t9;
  let t10;
  if ($[24] !== videos) {
    t10 = videos.filter(_temp4);
    $[24] = videos;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const validVideos = t10;
  const hasMedia = videos.length > 0 || images.length > 0;
  const isWaitingForVideos = isVideoLoading && validVideos.length <= 0;
  const canAutoPlayImage = currentMedia?.type === MEDIA_TYPE.IMAGE && hasMedia && !isWaitingForVideos;
  const delay = currentMedia?.type === MEDIA_TYPE.IMAGE && "duration" in currentMedia ? currentMedia.duration : CAROUSEL_DURATION_MS;
  let t11;
  if ($[26] !== canAutoPlayImage || $[27] !== goNext) {
    t11 = () => {
      if (canAutoPlayImage) {
        goNext();
      }
    };
    $[26] = canAutoPlayImage;
    $[27] = goNext;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  useInterval(t11, canAutoPlayImage ? delay : null);
  let t12;
  if ($[29] !== backgroundPlay || $[30] !== containerClassName || $[31] !== currentIndex || $[32] !== currentMedia || $[33] !== goNext || $[34] !== handleVideoEnded || $[35] !== isEmpty || $[36] !== isLoading || $[37] !== mediaList || $[38] !== playKey) {
    t12 = {
      mediaList,
      currentIndex,
      setCurrentIndex,
      currentMedia,
      handleVideoEnded,
      playKey,
      goNext,
      isLoading,
      isEmpty,
      backgroundPlay,
      containerClassName
    };
    $[29] = backgroundPlay;
    $[30] = containerClassName;
    $[31] = currentIndex;
    $[32] = currentMedia;
    $[33] = goNext;
    $[34] = handleVideoEnded;
    $[35] = isEmpty;
    $[36] = isLoading;
    $[37] = mediaList;
    $[38] = playKey;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};
function _temp(video_1) {
  return {
    ...video_1,
    type: MEDIA_TYPE.VIDEO
  };
}
function _temp2(image) {
  return {
    ...image,
    type: MEDIA_TYPE.IMAGE
  };
}
function _temp3(key) {
  return key + 1;
}
function _temp4(v) {
  return v.isConverted || v.url;
}